import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusRegistrationResult } from '@main/bus-layer/bus-registration';
import { BusRegistration } from '@main/bus-layer/bus-registration';
import { BusServices } from '@main/bus-layer/bus-services';

export class BusLayer {
  private static initPromise: Promise<
    [HTMLIFrameElement, BusRegistrationResult]
  > | null = null;

  static async init(): Promise<[HTMLIFrameElement, BusRegistrationResult]> {
    if (this.initPromise) {
      return this.initPromise;
    }
    this.initPromise = (async () => {
      const iframeUrl = `${process.env.BUS_URL}/${process.env.BUS_VERSION}/`;
      const iframe = await BusIframe.addIframe(iframeUrl);
      const registrationResult = await BusRegistration.register(iframe);

      if (registrationResult.currentUser) {
        await BusServices.init(iframe);
        await BusServices.storeAgentList(iframe);
        // Fetch teams in the background so a missing/slow SEARCH_TEAMS
        // response can never block the connector (call screen) from loading.
        BusServices.storeTeamList(iframe).catch((error) =>
          console.error('Error while fetching team list', error),
        );
      }
      if (registrationResult.company) {
        await BusServices.subscribeIntegrationSettingUpdate(
          iframe,
          registrationResult.company.id,
        );
      }

      return [iframe, registrationResult];
    })();

    return this.initPromise;
  }

  static async destroy(): Promise<void> {
    try {
      if (this.initPromise) {
        const [iframe, _] = await this.initPromise;
        if (iframe) {
          await BusServices.destroy(iframe);
          iframe.remove();
        }
      }
    } catch (error) {
      console.error('Error while destroying bus layer', error);
    }
    this.initPromise = null;
  }
}
